interface KaraokeWhatsAppButtonProps {
  lang: 'en' | 'ja';
}

export default function KaraokeWhatsAppButton({ lang }: KaraokeWhatsAppButtonProps) {
  const handleClick = () => {
    const message = lang === 'en' 
      ? 'Hi! I\'d like to book Tokyo Karaoke Night experience.'
      : 'こんにちは！Tokyo Karaoke Nightの予約をしたいです。';
    window.open(`https://wa.me/818041800418?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 px-6 py-4 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-bold rounded-full shadow-2xl hover:shadow-pink-500/50 transition-all duration-300 hover:scale-105 whitespace-nowrap"
      aria-label={lang === 'en' ? 'Book via WhatsApp' : 'WhatsAppで予約'}
    >
      <i className="ri-whatsapp-line text-2xl"></i>
      <span className="hidden sm:inline">
        {lang === 'en' ? 'Book Now' : '予約する'}
      </span>
      <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full animate-ping"></div>
      <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full"></div>
    </button>
  );
}